import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'

export const pascalCase = (string: string): string => upperFirst(camelCase(string))